"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7585],{

/***/ 45672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _dnd_kit_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60887);
/* harmony import */ var _dnd_kit_modifiers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32339);
/* harmony import */ var _dnd_kit_sortable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45587);
/* harmony import */ var _dnd_kit_utilities__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24285);
/* harmony import */ var _libs_useTheme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5779);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var react_icons_go__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66653);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57632);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51773);










const Table = (param)=>{
    let { tableHeading , rows , sortable =false , onSort , items  } = param;
    const { theme  } = (0,_libs_useTheme__WEBPACK_IMPORTED_MODULE_5__/* .useTheme */ .Fg)();
    const random_id = (0,uuid__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
    const getParsedRows = ()=>{
        return rows === null || rows === void 0 ? void 0 : rows.map((r, index)=>({
                data: r,
                id: index
            }));
    };
    const [parsedRows, setParsedRows] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(getParsedRows());
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(()=>{
        setParsedRows(getParsedRows());
    }, [
        rows
    ]);
    const dragEndHandler = (e)=>{
        const { active , over  } = e;
        if (over && active.id !== over.id && parsedRows && items) {
            const oldIndex = parsedRows === null || parsedRows === void 0 ? void 0 : parsedRows.findIndex((f)=>{
                return f.id === active.id;
            });
            const newIndex = parsedRows === null || parsedRows === void 0 ? void 0 : parsedRows.findIndex((f)=>{
                return f.id === over.id;
            });
            const rowsPayload = (0,_dnd_kit_sortable__WEBPACK_IMPORTED_MODULE_3__/* .arrayMove */ .Rp)(parsedRows, oldIndex, newIndex);
            setParsedRows(rowsPayload);
            const payload = (0,_dnd_kit_sortable__WEBPACK_IMPORTED_MODULE_3__/* .arrayMove */ .Rp)(items, oldIndex, newIndex);
            if (onSort) onSort(payload);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("table", {
        className: "w-full table-auto text-left rounded-lg border border-midnight-gray",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
                className: "",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tr", {
                    style: {
                        backgroundColor: theme.foregroundColour
                    },
                    className: "border-b-midnight-gray border-b",
                    children: tableHeading.map((t)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                            className: "p-3",
                            children: t
                        }, "table-head-".concat(random_id, "-").concat(t.toString().length > 0 ? t.toString() : (0,uuid__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)())))
                }, "table-head-".concat(random_id, "-container"))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tbody", {
                children: sortable && !!parsedRows ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dnd_kit_core__WEBPACK_IMPORTED_MODULE_1__/* .DndContext */ .LB, {
                    modifiers: [
                        _dnd_kit_modifiers__WEBPACK_IMPORTED_MODULE_2__/* .restrictToVerticalAxis */ .DL
                    ],
                    onDragEnd: dragEndHandler,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dnd_kit_sortable__WEBPACK_IMPORTED_MODULE_3__/* .SortableContext */ .Fo, {
                        items: parsedRows,
                        strategy: _dnd_kit_sortable__WEBPACK_IMPORTED_MODULE_3__/* .verticalListSortingStrategy */ .qw,
                        children: parsedRows === null || parsedRows === void 0 ? void 0 : parsedRows.map((row, index)=>{
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TableItem, {
                                sortable: true,
                                id: row.id,
                                className: "py-2 border-b-midnight-gray border-b bg-white",
                                children: row.data.map((t, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        className: "p-3",
                                        children: index === 3 && t === "Break" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "rounded border border-orange-200 text-orange-200 py-0.5 px-1 text-sm",
                                            children: "Break"
                                        }) : t
                                    }, "table-data-".concat(random_id, "-").concat(i)))
                            }, "".concat(row.id));
                        })
                    })
                }) : parsedRows === null || parsedRows === void 0 ? void 0 : parsedRows.map((row, index)=>{
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TableItem, {
                        id: row.id,
                        className: "py-2 border-b-midnight-gray border-b",
                        children: row.data.map((t, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                className: "p-3",
                                children: index === 3 && t === "Break" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "rounded border border-orange-200 text-orange-200 py-0.5 px-1 text-sm",
                                    children: "Break"
                                }) : t
                            }, "table-data-".concat(random_id, "-").concat(i)))
                    }, "".concat(row.id));
                })
            })
        ]
    });
};
const TableItem = (param)=>{
    let { children , className , id , key , sortable =false  } = param;
    const { attributes , listeners , setNodeRef , transform , transition  } = (0,_dnd_kit_sortable__WEBPACK_IMPORTED_MODULE_3__/* .useSortable */ .nB)({
        id
    });
    const style = {
        transform: _dnd_kit_utilities__WEBPACK_IMPORTED_MODULE_4__/* .CSS.Transform.toString */ .ux.Transform.toString(transform),
        transition
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tr", {
        ref: setNodeRef,
        style: style,
        className: "p-3 ".concat(className),
        children: !!sortable ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                children,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                    className: "py-3",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Box__WEBPACK_IMPORTED_MODULE_7__["default"], {
                        className: "",
                        ...attributes,
                        ...listeners,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_go__WEBPACK_IMPORTED_MODULE_9__/* .GoGrabber */ .gMO, {})
                    })
                })
            ]
        }) : children
    }, "table-row-".concat(id, " relative"));
};
/* harmony default export */ __webpack_exports__["Z"] = (Table);


/***/ }),

/***/ 85026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Tab; },
/* harmony export */   "m": function() { return /* binding */ Tabs; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);


const Tab = (param)=>{
    let { children , title  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
const Tabs = (param)=>{
    let { activeTitle , children , stickyHeader =false , className  } = param;
    const activeTab = children.filter((c)=>c !== false).find((c)=>c.props.title === activeTitle);
    if (className) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
        className: className,
        children: activeTab
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: activeTab
    });
};


/***/ }),

/***/ 51062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ EmailPreview; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./libs/CreateEventContext.tsx
var CreateEventContext = __webpack_require__(4568);
// EXTERNAL MODULE: ./libs/Auth/useAuth.ts + 3 modules
var useAuth = __webpack_require__(24499);
// EXTERNAL MODULE: ./libs/useOrganisationProfile.ts
var useOrganisationProfile = __webpack_require__(19058);
// EXTERNAL MODULE: ./libs/Utility/resizeable.tsx
var resizeable = __webpack_require__(58118);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/inputs/RichTextEditor/TextEditorUtil.tsx
var TextEditorUtil = __webpack_require__(99212);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./libs/EventTime/index.ts + 26 modules
var EventTime = __webpack_require__(26647);
;// CONCATENATED MODULE: ./components/email-builder/util.tsx



const domain = "forumm.to";
const PLATFORM_URL = "".concat(domain.includes("qa") || domain.includes("app") ? "https://" : "http://").concat(domain, "/event/");
// console.log({ PLATFORM_URL, domain })
const getEmailStyle = ()=>"\n    <style>\n        img {\n            border: none;\n            -ms-interpolation-mode: bicubic;\n            max-width: 100%;\n        }\n        .img-logo {\n          max-width: 150px;\n          min-width: 70px;\n\n          max-height: 150px;\n          min-height: 70px;\n\n          height: 35%;\n          width: auto;\n          border-radius: 6px;\n        }\n        .logo-landscape {\n          min-height: 50px !important;\n          max-width: 175px !important;\n          margin: 10px !important;\n        }\n\n        body {\n            background-color: #f6f6f6;\n            font-family: sans-serif;\n            -webkit-font-smoothing: antialiased;\n            font-size: 14px;\n            line-height: 1.4;\n            margin: 0;\n            padding: 0;\n            -ms-text-size-adjust: 100%;\n            -webkit-text-size-adjust: 100%;\n        }\n\n        table {\n            border-collapse: separate;\n            width: 100%;\n        }\n\n        table td {\n            font-family: sans-serif;\n            font-size: 14px;\n            vertical-align: top;\n        }\n\n        .body {\n            background-color: #f6f6f6;\n            width: 100%;\n        }\n\n        .container {\n            display: block;\n            margin: 0 auto !important;\n            max-width: 580px;\n            padding: 10px;\n            width: 580px;\n        }\n\n        .content {\n            box-sizing: border-box;\n            display: block;\n            margin: 0 auto;\n            max-width: 580px;\n            padding: 10px;\n        }\n\n        .main {\n            background: #ffffff;\n            border-radius: 3px;\n            width: 100%;\n        }\n\n        .wrapper {\n            box-sizing: border-box;\n            padding: 20px;\n        }\n\n        .content-block {\n            padding-bottom: 10px;\n            padding-top: 10px;\n        }\n\n        .footer {\n            clear: both;\n            margin-top: 10px;\n            text-align: center;\n            width: 100%;\n        }\n\n        .footer td,\n        .footer p,\n        .footer span,\n        .footer a {\n            color: #999999;\n            font-size: 12px;\n            text-align: center;\n        }\n\n        h1,\n        h2,\n        h3,\n        h4 {\n            color: #000000;\n            font-family: sans-serif;\n            font-weight: 400;\n            line-height: 1.4;\n            margin: 0;\n            margin-bottom: 30px;\n        }\n\n        h1 {\n            font-size: 35px;\n            font-weight: 300;\n            text-align: center;\n            text-transform: capitalize;\n        }\n\n        p,\n        ul,\n        ol {\n            font-family: sans-serif;\n            font-size: 14px;\n            font-weight: normal;\n            margin: 0;\n            margin-bottom: 15px;\n        }\n\n        p li,\n        ul li,\n        ol li {\n            list-style-position: inside;\n            margin-left: 5px;\n        }\n                  \n        ol.gap-1 li {\n          margin-bottom: 6px;\n        }\n\n        ol li p {\n          display: inline;\n        }\n\n        a {\n            color: #3498db;\n            text-decoration: underline;\n        }\n\n        .btn {\n            box-sizing: border-box;\n            width: 100%;\n        }\n\n        .btn>tbody>tr>td {\n            padding-bottom: 15px;\n        }\n\n        .btn table {\n            width: auto;\n        }\n\n        .btn table td {\n            background-color: #ffffff;\n            border-radius: 5px;\n            text-align: center;\n        }\n\n        .btn a {\n            background-color: #ffffff;\n            border: solid 1px #3498db;\n            border-radius: 5px;\n            box-sizing: border-box;\n            color: #3498db;\n            cursor: pointer;\n            display: inline-block;\n            font-size: 14px;\n            font-weight: bold;\n            margin: 0;\n            padding: 12px 25px;\n            text-decoration: none;\n            text-transform: capitalize;\n        }\n\n        .btn-primary table td {\n            background-color: #3498db;\n        }\n\n        .btn-primary a {\n            background-color: #3498db;\n            border-color: #3498db;\n            color: #ffffff;\n        }\n\n        .last {\n            margin-bottom: 0;\n        }\n\n        .first {\n            margin-top: 0;\n        }\n\n        .align-center {\n            text-align: center;\n        }\n\n        .align-right {\n            text-align: right;\n        }\n\n        .align-left {\n            text-align: left;\n        }\n\n        .clear {\n            clear: both;\n        }\n\n        .mt0 {\n            margin-top: 0;\n        }\n\n        .mb0 {\n            margin-bottom: 0;\n        }\n\n        .preheader {\n            color: transparent;\n            display: none;\n            height: 0;\n            max-height: 0;\n            max-width: 0;\n            opacity: 0;\n            overflow: hidden;\n            visibility: hidden;\n            width: 0;\n        }\n\n        .powered-by a {\n            text-decoration: none;\n        }\n\n        hr {\n            border: 0;\n            border-bottom: 1px solid #f6f6f6;\n            margin: 20px 0;\n        }\n\n        @media only screen and (max-width: 620px) {\n            table.body h1 {\n                font-size: 28px !important;\n                margin-bottom: 10px !important;\n            }\n\n            table.body p,\n            table.body ul,\n            table.body ol,\n            table.body td,\n            table.body span,\n            table.body a {\n                font-size: 16px !important;\n            }\n\n            table.body .wrapper,\n            table.body .article {\n                padding: 10px !important;\n            }\n\n            table.body .content {\n                padding: 0 !important;\n            }\n\n            table.body .container {\n                padding: 0 !important;\n                width: 100% !important;\n            }\n\n            table.body .btn table {\n                width: 100% !important;\n            }\n\n            table.body .btn a {\n                width: 100% !important;\n            }\n\n            table.body .img-responsive {\n                height: auto !important;\n                max-width: 100% !important;\n                width: auto !important;\n            }\n        }\n\n        @media all {\n            .ExternalClass {\n                width: 100%;\n            }\n\n            .ExternalClass,\n            .ExternalClass p,\n            .ExternalClass span,\n            .ExternalClass font,\n            .ExternalClass td,\n            .ExternalClass div {\n                line-height: 100%;\n            }\n\n            .apple-link a {\n                color: inherit !important;\n                font-family: inherit !important;\n                font-size: inherit !important;\n                font-weight: inherit !important;\n                line-height: inherit !important;\n                margin: 0 !important;\n                text-decoration: none !important;\n            }\n\n            .btn-primary table td:hover {\n                background-color: #34495e !important;\n            }\n\n            .btn-primary a:hover {\n                background-color: #34495e !important;\n                border-color: #34495e !important;\n            }\n        }\n    </style>\n";
const getLogoImage = (imgURL)=>'<a href="#"><img src="'.concat(imgURL !== null && imgURL !== void 0 ? imgURL : "https://static.wixstatic.com/media/7fc37b_02f9a20bf6e346fc9461ce658699b7d9~mv2.png/v1/crop/x_126,y_104,w_513,h_563/fill/w_78,h_85,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Forumm%20Logo%20Transparent.png", '" alt="forumm-logo" class="img-logo" /></a>');
const getEmailHead = (title)=>'\n    <!doctype html>\n    <html>\n        <head>\n            <meta name="viewport" content="width=device-width, initial-scale=1.0" />\n            <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />\n            <title>'.concat(title !== null && title !== void 0 ? title : "Confirmed Booking", "</title>\n            ").concat(getEmailStyle(), "\n        </head>\n");
const getEmailBodyWrapper = (content, logoUrl)=>{
    return '\n    <body>\n    <span class="preheader">Email Preview</span>\n    <table role="presentation" border="0" cellpadding="0" cellspacing="0" class="body">\n        <tr>\n            <td>&nbsp;</td>\n            <td class="container">\n                <div class="content">\n                    <table role="presentation" class="main">\n                        <tr>\n                            <td class="wrapper">\n                                <table role="presentation" border="0" cellpadding="0" cellspacing="0">\n                                    <tr>\n                                        <td class="align-center">\n                                          '.concat(getLogoImage(logoUrl), "\n                                        </td>\n                                    </tr>\n                                    <tr>\n                                        <td>\n                                            ").concat(content, '\n                                        </td>\n                                    </tr>\n                                </table>\n                            </td>\n                        </tr>\n                    </table>\n                    <div class="footer">\n                        <table role="presentation" border="0" cellpadding="0" cellspacing="0">\n                            <tr>\n                                <td class="content-block">\n                                    <span class="apple-link">Forumm</span>\n                                    <br> Want to explore more? Visit us at <a href="https://www.forumm.to/">forumm.to</a>.\n                                </td>\n                            </tr>\n                        </table>\n                    </div>\n                </div>\n            </td>\n            <td>&nbsp;</td>\n        </tr>\n    </table>\n    </body>\n    </html>\n');
};
// const PLACEHOLDER_REGEX = /{\{\s*[\w]+\s*}}/g
const findWithRegex = (regex, content)=>{
    return regex.exec(content);
};
const prepContent = function(content, data) {
    let type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "event";
    let payload = content;
    let hasMore = false;
    const event = type === "event" ? data : undefined;
    const match = findWithRegex((0,TextEditorUtil/* PLACEHOLDER_REGEX */.qj)(type), payload);
    if (match !== null && typeof (match === null || match === void 0 ? void 0 : match[0]) === "string") {
        let parsedData = [];
        if (type === "event") {
            var ref, ref1;
            var ref2, ref3;
            parsedData = [
                [
                    "eventlocation",
                    (ref2 = event === null || event === void 0 ? void 0 : (ref = event.event) === null || ref === void 0 ? void 0 : ref.eventLocationMapLink) !== null && ref2 !== void 0 ? ref2 : event === null || event === void 0 ? void 0 : (ref1 = event.event) === null || ref1 === void 0 ? void 0 : ref1.eventLocation
                ],
                ...Object.entries((ref3 = event === null || event === void 0 ? void 0 : event.event) !== null && ref3 !== void 0 ? ref3 : {}),
                [
                    "eventlink",
                    '<a href="'.concat(PLATFORM_URL).concat(event === null || event === void 0 ? void 0 : event.eventId, '">Event Page</a>')
                ]
            ];
        }
        if (type === "membership") {
            const membership = data;
            parsedData = [
                ...Object.entries(membership !== null && membership !== void 0 ? membership : {})
            ];
        }
        // console.log({
        //   type,
        //   match: match?.[0],
        //   firstname: match?.[0].toLowerCase().includes('firstname'),
        //   lastname: match?.[0].toLowerCase().includes('lastname'),
        //   starttime: match?.[0].toLowerCase().includes('starttime'),
        //   title: match?.[0].toLowerCase().includes('title'),
        //   qr: match?.[0].toLowerCase().includes('qr'),
        // })
        TextEditorUtil/* TextEditorPlaceholders.forEach */.js.forEach((p)=>{
            const val = p.value.trim() // {{firstname}}
            ;
            const key = val.slice(2, -2) // firstname
            ;
            if (payload.toLowerCase().includes(val)) {
                let data;
                if (p.useRealDataIfAvailable) {
                    var ref;
                    data = (ref = parsedData.find((f)=>f[0].toLowerCase() === key.toLowerCase())) === null || ref === void 0 ? void 0 : ref[1];
                } else data = p.dummyData;
                if (moment_default()(data, (moment_default()).ISO_8601, true).isValid()) {
                    data = event ? (0,EventTime/* getEventDateTime */.CD)(data, event.event).toFormat("d LLL yyyy, HH:mm") : moment_default()(data).format("D MMMM YYYY, h:mm A");
                }
                payload = payload.replaceAll(val, data !== null && data !== void 0 ? data : "Unsupported Data");
            }
        });
    }
    // PLACEHOLDER_REGEX.lastIndex = 0
    hasMore = findWithRegex((0,TextEditorUtil/* PLACEHOLDER_REGEX */.qj)(type), payload) !== null;
    // console.log({
    //   match,
    //   hasMore,
    //   cond: match !== null && typeof match?.[0] === 'string',
    //   payload,
    // })
    if (hasMore) return prepContent(payload, data);
    return payload;
};
const getEmailPreviewContent = function(content, title, logoUrl, data) {
    let type = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "event";
    const preppedContent = prepContent(content, data, type);
    const email = getEmailHead().concat(getEmailBodyWrapper(preppedContent, logoUrl));
    return email;
};

;// CONCATENATED MODULE: ./components/email-builder/emailPreview.tsx







const EmailPreview = (param)=>{
    let { content , resizeEnabled =true , show =true , data , type ="event"  } = param;
    const { profile  } = (0,useAuth/* useAuth */.aC)();
    const { formData  } = (0,react.useContext)(CreateEventContext/* CreateEventContext */.s);
    const org = (0,useOrganisationProfile/* useOrganisationProfile */.k)(profile === null || profile === void 0 ? void 0 : profile.company);
    const [height, setHeight] = (0,react.useState)();
    const iframeRef = (0,react.useRef)(null);
    const emailContent = getEmailPreviewContent(content, "Test", org.profile.logoImage, data !== null && data !== void 0 ? data : formData, type);
    (0,react.useEffect)(()=>{
        var ref;
        const iframe = iframeRef.current;
        if (!iframe || !content) return;
        // Write the full HTML document into the iframe
        const doc = iframe.contentDocument || ((ref = iframe.contentWindow) === null || ref === void 0 ? void 0 : ref.document);
        iframe;
        if (doc) {
            doc.open();
            // doc.append(emailContent)
            doc.write(emailContent);
            doc.close();
            // Optional: Auto-resize iframe to content height
            // const resize = () => {
            //   if (iframe.contentWindow) {
            //     setHeight(iframe.contentWindow.document.body.scrollHeight)
            //   }
            // }
            // Wait for styles/images to load
            iframe.onload = ()=>{
                doc.addEventListener("click", (e)=>{
                    e.preventDefault() // 🚫 stop navigation
                    ;
                });
            };
        // iframe.onload = () => {
        // setTimeout(resize, 100) // small delay for fonts/images
        // }
        // Also resize on window resize or content change
        // window.addEventListener('resize', resize)
        // return () => window.removeEventListener('resize', resize)
        }
    }, [
        content,
        show
    ]);
    if (!show) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(resizeable/* default */.Z, {
            className: "h-full w-full flex-1",
            enabled: resizeEnabled,
            initalSize: {
                height: "full"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                ref: iframeRef,
                title: "Email Preview",
                className: "w-full h-full rounded border border-white border-solid border-opacity-25 relative",
                onClick: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                },
                style: {
                    width: "100%",
                    height: "100%",
                    border: "1px solid #ddd",
                    borderRadius: "8px"
                },
                sandbox: "allow-same-origin" // improve security
            })
        })
    });
};


/***/ }),

/***/ 88378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ SCHEDULED_EMAIL_TRIGGER; }
/* harmony export */ });
/* harmony import */ var _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68240);

const SCHEDULED_EMAIL_TRIGGER = _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .EventEmailTrigger.Scheduled */ .bQ.Scheduled;


/***/ }),

/***/ 79656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ok": function() { return /* binding */ clearEmailContentCache; }
/* harmony export */ });
/* unused harmony export getEmailContentCacheKey */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _components_base_Tabs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85026);
/* harmony import */ var _components_base_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40517);
/* harmony import */ var _components_inputs_CheckboxInput__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98805);
/* harmony import */ var _components_inputs_DropdownInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61993);
/* harmony import */ var _components_inputs_DateTimeInput__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8194);
/* harmony import */ var _components_inputs_RichTextEditor_RichTextEditor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19460);
/* harmony import */ var _components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39618);
/* harmony import */ var _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68240);
/* harmony import */ var _libs_CreateEventContext__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4568);
/* harmony import */ var _libs_EventTime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26647);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(67294);
/* harmony import */ var _emailbuilder_type__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(88378);
/* harmony import */ var _emailPreview__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(51062);
/* harmony import */ var _libs_useLocalStorage__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(3830);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(57632);


















const getEmailContentCacheKey = (param)=>{
    let { type ="event" , scopeId , template  } = param;
    var ref;
    const trigger = (ref = template === null || template === void 0 ? void 0 : template.trigger) !== null && ref !== void 0 ? ref : _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .EventEmailTrigger.Confirmation */ .bQ.Confirmation;
    var ref1;
    const templateId = (ref1 = template === null || template === void 0 ? void 0 : template.templateId) !== null && ref1 !== void 0 ? ref1 : (template === null || template === void 0 ? void 0 : template.editIndex) === 0 || (template === null || template === void 0 ? void 0 : template.editIndex) ? "index-".concat(template.editIndex) : "new-".concat(trigger);
    return [
        "email-content-cache",
        type,
        scopeId !== null && scopeId !== void 0 ? scopeId : "draft",
        templateId
    ].join("-");
};
const clearEmailContentCache = (params)=>{
    if (false) {}
    window.localStorage.removeItem(getEmailContentCacheKey(params));
};
const EmailBuilderUI = (param)=>{
    let { enablePreview , onSubmit , setError , template , decorators , data , type ="event" , cacheScopeId  } = param;
    var ref, ref1, ref2, ref3;
    const { formData , setFormData , validationRules , errors , setErrors  } = (0,react__WEBPACK_IMPORTED_MODULE_13__.useContext)(_libs_CreateEventContext__WEBPACK_IMPORTED_MODULE_10__/* .CreateEventContext */ .s);
    var ref4;
    const [emailTrigger, setEmailTrigger] = (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)((ref4 = template === null || template === void 0 ? void 0 : template.trigger) !== null && ref4 !== void 0 ? ref4 : _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .EventEmailTrigger.Manual */ .bQ.Manual);
    var ref5;
    const [scheduledAt, setScheduledAt] = (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)((ref5 = template === null || template === void 0 ? void 0 : (ref = template.schedule) === null || ref === void 0 ? void 0 : ref.runAt) !== null && ref5 !== void 0 ? ref5 : "");
    const [scheduleId] = (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)((template === null || template === void 0 ? void 0 : (ref1 = template.schedule) === null || ref1 === void 0 ? void 0 : ref1.status) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .NotificationStatus.Sent */ .Ez.Sent ? (0,uuid__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)() : (template === null || template === void 0 ? void 0 : (ref2 = template.schedule) === null || ref2 === void 0 ? void 0 : ref2.scheduleId) || (0,uuid__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)());
    var ref6;
    const eventTimeZoneId = (ref6 = (0,_libs_EventTime__WEBPACK_IMPORTED_MODULE_11__/* .getEventTimeZoneId */ .br)(formData === null || formData === void 0 ? void 0 : formData.event)) !== null && ref6 !== void 0 ? ref6 : (0,_libs_EventTime__WEBPACK_IMPORTED_MODULE_11__/* .getBrowserTimeZoneId */ .ot)();
    var ref7;
    const initialContent = (ref7 = template === null || template === void 0 ? void 0 : template.content) !== null && ref7 !== void 0 ? ref7 : "<p>Write your email here.</p>";
    var ref8;
    const scopeId = cacheScopeId !== null && cacheScopeId !== void 0 ? cacheScopeId : type === "membership" ? data === null || data === void 0 ? void 0 : data.membershipId : (ref8 = data === null || data === void 0 ? void 0 : data.eventId) !== null && ref8 !== void 0 ? ref8 : formData === null || formData === void 0 ? void 0 : formData.eventId;
    const emailContentCacheKey = getEmailContentCacheKey({
        type,
        scopeId,
        template
    });
    const [emailContentCache, setEmailContentCache] = (0,_libs_useLocalStorage__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(emailContentCacheKey, null);
    var ref9, ref10, ref11;
    const [emailContent, setEmailContent] = (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)({
        data: (ref10 = (ref9 = emailContentCache === null || emailContentCache === void 0 ? void 0 : emailContentCache.data) !== null && ref9 !== void 0 ? ref9 : template === null || template === void 0 ? void 0 : template.data) !== null && ref10 !== void 0 ? ref10 : "",
        markup: (ref11 = emailContentCache === null || emailContentCache === void 0 ? void 0 : emailContentCache.markup) !== null && ref11 !== void 0 ? ref11 : initialContent
    });
    var ref12;
    const [emailTitle, setEmailTitle] = (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)((ref12 = template === null || template === void 0 ? void 0 : template.title) !== null && ref12 !== void 0 ? ref12 : "Reminder");
    const [emailStatus, setEmailStatus] = (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)((template === null || template === void 0 ? void 0 : template.enabled) || true);
    const [showPreview, setShowPreview] = (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)(!!onSubmit);
    const isScheduled = emailTrigger === _emailbuilder_type__WEBPACK_IMPORTED_MODULE_14__/* .SCHEDULED_EMAIL_TRIGGER */ .Q;
    const scheduleError = isScheduled ? !scheduledAt ? "Choose when this email should be sent." : !moment__WEBPACK_IMPORTED_MODULE_12___default()(scheduledAt).isAfter(moment__WEBPACK_IMPORTED_MODULE_12___default()()) ? "Scheduled send time must be in the future." : undefined : undefined;
    (0,react__WEBPACK_IMPORTED_MODULE_13__.useEffect)(()=>{
        var ref, ref1;
        if (!!onSubmit) {
            var ref2;
            var _status;
            return onSubmit({
                trigger: emailTrigger,
                schedule: isScheduled && scheduledAt ? {
                    scheduleId,
                    runAt: scheduledAt,
                    status: (template === null || template === void 0 ? void 0 : (ref2 = template.schedule) === null || ref2 === void 0 ? void 0 : ref2.runAt) === scheduledAt && template.schedule.scheduleId === scheduleId && template.schedule.status !== _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .NotificationStatus.Failed */ .Ez.Failed ? (_status = template.schedule.status) !== null && _status !== void 0 ? _status : _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .NotificationStatus.Processing */ .Ez.Processing : _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .NotificationStatus.Processing */ .Ez.Processing
                } : undefined,
                content: emailContent.markup,
                data: emailContent.data,
                enabled: emailStatus,
                title: emailTitle,
                editIndex: template === null || template === void 0 ? void 0 : template.editIndex,
                originalTitle: template === null || template === void 0 ? void 0 : template.originalTitle,
                legacyScheduleTimestamp: template === null || template === void 0 ? void 0 : template.legacyScheduleTimestamp
            });
        }
        // return console.log(
        //   `[EmailBuilder]: Custom submit handler detected bypassing direct update.`
        // )
        const payload = !!(formData === null || formData === void 0 ? void 0 : formData.emailTemplates) && (formData === null || formData === void 0 ? void 0 : (ref = formData.emailTemplates) === null || ref === void 0 ? void 0 : ref.length) > 0 ? formData === null || formData === void 0 ? void 0 : (ref1 = formData.emailTemplates) === null || ref1 === void 0 ? void 0 : ref1.map((m)=>{
            if (m.trigger !== emailTrigger) return m;
            return {
                ...m,
                content: emailContent.markup,
                data: emailContent.data,
                enabled: emailStatus,
                title: emailTitle
            };
        }) : [
            {
                trigger: emailTrigger,
                content: emailContent.markup,
                data: emailContent.data,
                enabled: emailStatus,
                title: emailTitle
            }
        ];
        setFormData({
            ...formData,
            emailTemplates: payload
        });
    }, [
        emailContent,
        emailStatus,
        emailTrigger,
        emailTitle,
        scheduledAt
    ]);
    // console.log({ decorators })
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
        className: "size-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                show: !onSubmit,
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_DropdownInput__WEBPACK_IMPORTED_MODULE_5__/* .DropdownInput */ .f, {
                        options: [
                            {
                                label: "Confirmation Email",
                                value: _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .EventEmailTrigger.Confirmation */ .bQ.Confirmation
                            }
                        ],
                        onChange: (op)=>setEmailTrigger(op),
                        className: "mt-6 mb-4",
                        maxWidth: "300px",
                        label: "Select Email Template"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_CheckboxInput__WEBPACK_IMPORTED_MODULE_4__/* .CheckboxInput */ .I, {
                        show: !onSubmit,
                        value: showPreview,
                        onChange: (data)=>{
                            setShowPreview(data);
                        },
                        className: "bg-transparent rounded text-sm border-box",
                        border: "",
                        label: "",
                        required: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            children: "Show Email Preview"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_CheckboxInput__WEBPACK_IMPORTED_MODULE_4__/* .CheckboxInput */ .I, {
                        show: !onSubmit,
                        value: emailStatus,
                        onChange: (data)=>{
                            setEmailStatus(data);
                        },
                        className: "bg-transparent rounded text-sm border-box",
                        border: "",
                        label: "",
                        required: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            children: "Use this template"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "flex flex-col md:flex-row h-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        className: "flex-1 md:flex-2 flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                className: "flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_8__/* .TextInput */ .o, {
                                        validations: {
                                            minLength: {
                                                value: 2,
                                                message: "Email template title must be at least 2 characters"
                                            }
                                        },
                                        label: "Subject Line",
                                        type: "text",
                                        placeholder: "Reminder Template",
                                        onChange: (data)=>{
                                            var ref;
                                            setEmailTitle(data);
                                            if (formData === null || formData === void 0 ? void 0 : (ref = formData.emailTemplates) === null || ref === void 0 ? void 0 : ref.find((f)=>{
                                                var ref;
                                                return ((ref = f.title) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === data.toLowerCase();
                                            })) setErrors([
                                                ...errors,
                                                {
                                                    step: "notifications",
                                                    eleId: "EmailTemplateTitle",
                                                    message: "You must use a unique name for each email template"
                                                }
                                            ]);
                                            else {
                                                setErrors([
                                                    ...errors.filter((f)=>f.eleId !== "EmailTemplateTitle")
                                                ]);
                                            }
                                        },
                                        value: emailTitle,
                                        error: (ref3 = errors.find((e)=>e.eleId === "EmailTemplateTitle")) === null || ref3 === void 0 ? void 0 : ref3.message
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                        className: "flex items-center lg:items-start mb-2 lg:mb-0",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                            className: "flex flex-col lg:flex-row items-start",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_DropdownInput__WEBPACK_IMPORTED_MODULE_5__/* .DropdownInput */ .f, {
                                                    options: [
                                                        {
                                                            label: "Registration Confirmation",
                                                            value: _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .EventEmailTrigger.Confirmation */ .bQ.Confirmation,
                                                            show: emailTrigger === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .EventEmailTrigger.Confirmation */ .bQ.Confirmation,
                                                            disabled: true
                                                        },
                                                        {
                                                            label: "Manual Send",
                                                            value: _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .EventEmailTrigger.Manual */ .bQ.Manual,
                                                            disabled: emailTrigger === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .EventEmailTrigger.Confirmation */ .bQ.Confirmation,
                                                            show: emailTrigger !== _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .EventEmailTrigger.Confirmation */ .bQ.Confirmation
                                                        },
                                                        ...type === "event" && !!onSubmit ? [
                                                            {
                                                                label: "Scheduled Send",
                                                                value: _emailbuilder_type__WEBPACK_IMPORTED_MODULE_14__/* .SCHEDULED_EMAIL_TRIGGER */ .Q,
                                                                disabled: emailTrigger === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .EventEmailTrigger.Confirmation */ .bQ.Confirmation,
                                                                show: emailTrigger !== _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .EventEmailTrigger.Confirmation */ .bQ.Confirmation
                                                            }
                                                        ] : []
                                                    ],
                                                    onChange: (op)=>setEmailTrigger(op),
                                                    className: "mt-6 mb-4 mr-4",
                                                    value: emailTrigger,
                                                    autoWidth: true,
                                                    label: "Send Options"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                                    className: "text-sm font-light text-gray-500",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Tabs__WEBPACK_IMPORTED_MODULE_2__/* .Tabs */ .m, {
                                                        activeTitle: emailTrigger,
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Tabs__WEBPACK_IMPORTED_MODULE_2__/* .Tab */ .O, {
                                                                title: _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .EventEmailTrigger.Manual */ .bQ.Manual,
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "font-semibold",
                                                                        children: "Select where this email template will be used."
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                                    " ",
                                                                    "'",
                                                                    "Manual Send",
                                                                    "' ",
                                                                    "creates an email template that can be manually sent to all attendees."
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Tabs__WEBPACK_IMPORTED_MODULE_2__/* .Tab */ .O, {
                                                                title: _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .EventEmailTrigger.Confirmation */ .bQ.Confirmation,
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "font-semibold",
                                                                        children: "Select where this email template will be used."
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                                    " ",
                                                                    "'",
                                                                    " Registration Confirmation",
                                                                    "' ",
                                                                    "creates an email template that will be sent to attendee who register for your event."
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Tabs__WEBPACK_IMPORTED_MODULE_2__/* .Tab */ .O, {
                                                                title: _emailbuilder_type__WEBPACK_IMPORTED_MODULE_14__/* .SCHEDULED_EMAIL_TRIGGER */ .Q,
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "font-semibold",
                                                                        children: "Send this email automatically."
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                                    " Choose a future date and time. Current attendees and speakers will receive the latest saved version of this email."
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                        show: isScheduled,
                                        className: "mb-4 max-w-md rounded-2xl border border-gray-300 p-4",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_DateTimeInput__WEBPACK_IMPORTED_MODULE_6__/* .DateTimeInput */ .Y, {
                                                id: "email-schedule-time",
                                                label: "Send date and time",
                                                timeZoneId: eventTimeZoneId,
                                                required: true,
                                                value: scheduledAt,
                                                onChange: (value)=>setScheduledAt(value),
                                                placeholderText: "Choose a future date and time",
                                                filterDate: (date)=>moment__WEBPACK_IMPORTED_MODULE_12___default()(date).isSameOrAfter(moment__WEBPACK_IMPORTED_MODULE_12___default()(), "day"),
                                                filterTime: (time)=>moment__WEBPACK_IMPORTED_MODULE_12___default()(time).isAfter(moment__WEBPACK_IMPORTED_MODULE_12___default()()),
                                                error: scheduleError
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                className: "text-sm text-gray-600",
                                                children: "Send time follows event settings."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                className: "flex-1 flex flex-col ",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_RichTextEditor_RichTextEditor__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    decorators: decorators,
                                    resizeEnabled: false,
                                    tooltip: "Email Content",
                                    testid: "email-content-input",
                                    className: "relative max-h-[44vh] flex",
                                    setError: setError,
                                    label: "Email Content",
                                    placeholder: "Write your email here",
                                    value: emailContent.data,
                                    onChange: (res)=>{
                                        const { data , markup  } = res;
                                        if (!!data && !!markup) {
                                            setEmailContent({
                                                data,
                                                markup
                                            });
                                            setEmailContentCache({
                                                data,
                                                markup
                                            });
                                        }
                                    },
                                    htmlOutput: true
                                }, template === null || template === void 0 ? void 0 : template.trigger)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        className: "relative flex-1 lg:flex-3 ml-2 my-4 min-h-[44vh] flex",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_emailPreview__WEBPACK_IMPORTED_MODULE_15__/* .EmailPreview */ .M, {
                            resizeEnabled: false,
                            show: showPreview,
                            content: emailContent.markup,
                            data: data,
                            type: type
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (EmailBuilderUI);


/***/ }),

/***/ 29033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11390);



const TableRowActions = (param)=>{
    let { action =[] , deleteClicked , editClicked , confirmModal , disabled =false  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
        className: "flex",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "flex justify-end flex-1",
                children: action.map((a)=>{
                    var _title;
                    if (a.show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                        onClick: a.onClicked,
                        className: "ml-auto mr-2",
                        size: "small",
                        title: (_title = a.title) !== null && _title !== void 0 ? _title : "Action",
                        disabled: disabled,
                        confirmationModal: a.confirmModal,
                        loading: a.loading
                    }, a.title);
                })
            }),
            editClicked && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                onClick: editClicked,
                className: "ml-auto mr-2",
                size: "small",
                title: "Edit",
                disabled: disabled
            }),
            deleteClicked && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                onClick: deleteClicked,
                size: "small",
                title: "Remove",
                confirmationModal: !!confirmModal ? confirmModal : undefined,
                disabled: disabled
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TableRowActions);


/***/ }),

/***/ 98805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ CheckboxInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _components_tootilp_Tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73912);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _Validations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6686);





/**
 * Primary UI component for checkbox inputs.
 */ const CheckboxInput = (param)=>{
    let { label , show =true , value ="" , onChange , className , validations , required , testid , children , border ="border" , customStyles  } = param;
    const errorMessage = (0,_Validations__WEBPACK_IMPORTED_MODULE_4__/* .validate */ .G)(value, validations);
    const checked = value === true;
    if (!show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("fieldset", {
        className: "flex flex-col gap-3 bg-transparent text-sm transition-all ".concat(errorMessage ? "text-red-500" : "", " ").concat(className),
        children: [
            label && (border === null || border === void 0 ? void 0 : border.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("legend", {
                className: "text-sm font-medium text-[#153e3e] transition-all ".concat(errorMessage ? "text-red-500" : ""),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_tootilp_Tooltip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    show: required,
                    tooltip: "Required to publish.",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: required ? "after:content-['*'] after:ml-1 after:text-red-500" : "",
                        children: label
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: "flex w-full cursor-pointer items-start gap-2 text-sm font-medium text-[#153e3e] ".concat(customStyles !== null && customStyles !== void 0 ? customStyles : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        "data-testid": testid ? "".concat(testid) : null,
                        type: "checkbox",
                        className: "peer sr-only",
                        name: label,
                        checked: checked,
                        onClick: (e)=>{
                            e.stopPropagation();
                        },
                        onChange: (e)=>{
                            onChange && onChange(e.target.checked, false);
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        "aria-hidden": "true",
                        className: "mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center border-2 border-[#153e3e] bg-transparent transition-all after:hidden after:h-2 after:w-1 after:rotate-45 after:border-b-2 after:border-r-2 after:border-white peer-checked:bg-[#153e3e] peer-checked:after:block peer-focus-visible:ring-2 peer-focus-visible:ring-[#153e3e]/30"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        className: "min-w-0 text-[#153e3e]",
                        children: children
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                ignoreTheme: true,
                className: "transition-all ".concat(errorMessage ? "opacity-100" : "opacity-0", " text-red-500 text-sm font-bold"),
                children: errorMessage !== null && errorMessage !== void 0 ? errorMessage : "-"
            })
        ]
    });
};


/***/ })

}]);